export default "__VITE_ASSET__DefBYXJs__"